import {ActionIcon, Group, Text} from '@mantine/core'
import {IconMinus, IconPlus} from '@tabler/icons-react'

type BuildOutQuantityStepperProps = {
    value: number
    onChange: (value: number) => void
    ariaLabel?: string
    disabled?: boolean
}

export function BuildOutQuantityStepper({
    value,
    onChange,
    ariaLabel = 'Requirement quantity',
    disabled = false,
}: BuildOutQuantityStepperProps) {
    return (
        <Group
            gap={0}
            wrap="nowrap"
            role="group"
            aria-label={ariaLabel}
            style={{
                border: '1px solid var(--mantine-color-gray-4)',
                borderRadius: 'var(--mantine-radius-sm)',
                overflow: 'hidden',
                backgroundColor: 'var(--mantine-color-white)',
            }}
        >
            <ActionIcon
                variant="subtle"
                color="gray"
                radius={0}
                aria-label="Decrease requirement quantity"
                disabled={disabled || value <= 1}
                onClick={() => onChange(Math.max(1, value - 1))}
                style={{borderRight: '1px solid var(--mantine-color-gray-4)'}}
            >
                <IconMinus size={14} />
            </ActionIcon>
            <Text
                size="sm"
                fw={500}
                aria-label={ariaLabel}
                style={{minWidth: 32, textAlign: 'center', fontVariantNumeric: 'tabular-nums'}}
            >
                {value}
            </Text>
            <ActionIcon
                variant="subtle"
                color="gray"
                radius={0}
                aria-label="Increase requirement quantity"
                disabled={disabled}
                onClick={() => onChange(value + 1)}
                style={{borderLeft: '1px solid var(--mantine-color-gray-4)'}}
            >
                <IconPlus size={14} />
            </ActionIcon>
        </Group>
    )
}
